module.exports = __webpack_public_path__ + "static/media/lora4.ea3e48e7.jpg";